
import React, { useState, useEffect } from "react";
import "./Login.css";
import view from "./../../Assets/Images/Login/view.png";
import hide from "./../../Assets/Images/Login/hide.png";
import logo from "./../../Assets/Images/Navbar/blue_docity.png";
import whiteLogo from "./../../Assets/Images/Navbar/white_docity.png";
import { useNavigate } from "react-router-dom";
import AuthService from "../../Services/AuthService";
import { toast, ToastContainer } from "react-toastify";
import CivilStatusModal from "../CivilStatusModal/CivilStatusModal";
import { GoogleLogin } from '@react-oauth/google';

const Login = () => {
    const [toggle, setToggle] = useState("login");

    const [userName, setUserName] = useState("");
    const [userNameError, setUserNameError] = useState("");

    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState("");

    const [middleName, setMiddleName] = useState("");

    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState("");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [error, setError] = useState("");

    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const [passwordShow, setPasswordShow] = useState(false);
    const [passwordShow2, setPasswordShow2] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState("");

    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");

    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");

    const [engineerStatus, setEngineerStatus] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [timeLeft, setTimeLeft] = useState(0);

    const navigate = useNavigate();


    useEffect(() => {
        if (timeLeft <= 0) return;
        const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);


    const clean = (v) => v.replace(/\s+/g, "");
    const onlyDigits = (v) => v.replace(/\D/g, "");

    const validatePassword = (v) =>
        /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(v);
    const validateOtp = (v) => /^[0-9]+$/.test(v);


    const handleUserName = (e) => {
        let v = clean(e.target.value);
        setUserName(v);

        if (!v) setUserNameError("Username is required");
        else if (v.length < 3) setUserNameError("Username must be at least 3 characters");
        else setUserNameError("");
    };

    const handleFirstName = (e) => {
        let v = e.target.value.replace(/[^A-Za-z ]/g, "");
        setFirstName(v);
        if (!v.trim()) setFirstNameError("First Name is required");
        else setFirstNameError("");
    };

    const handleMiddleName = (e) => {
        let v = e.target.value.replace(/[^A-Za-z ]/g, "");
        setMiddleName(v);
    };

    const handleLastName = (e) => {
        let v = e.target.value.replace(/[^A-Za-z ]/g, "");
        setLastName(v);
        if (!v.trim()) setLastNameError("Last Name is required");
        else setLastNameError("");
    };

    const handleEmail = (e) => {
        let v = clean(e.target.value);
        setEmail(v);

        if (!v) {
            setEmailError("Email is required");
            return;
        }
        if (/\s/.test(v)) {
            setEmailError("Email must not contain spaces");
            return;
        }

        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)) {
            setEmailError("Enter a valid email address");
            return;
        }

        const domain = v.split("@")[1];
        const [name] = domain.split(".");

        if (name.length < 2) {
            setEmailError("Invalid email domain");
            return;
        }

        setEmailError("");
    };

    const handlePassword = (e) => {
        let v = clean(e.target.value);
        setPassword(v);

        if (!validatePassword(v))
            setPasswordError("Min 8 chars, 1 number & 1 special character");
        else setPasswordError("");
    };

    const handleConfirmPassword = (e) => {
        let v = clean(e.target.value);
        setConfirmPassword(v);

        if (password !== v) setConfirmPasswordError("Passwords do not match");
        else setConfirmPasswordError("");
    };

    const handlePhone = (e) => {
        let v = onlyDigits(e.target.value).slice(0, 10);
        setPhone(v);

        if (!v) {
            setPhoneError("Phone number is required");
            return;
        }
        if (v.length !== 10) {
            setPhoneError("Phone number must be 10 digits");
            return;
        }
        if (!/^[6-9]/.test(v)) {
            setPhoneError("Phone number must start with 6, 7, 8, or 9");
            return;
        }
        if (/^(\d)\1{9}$/.test(v)) {
            setPhoneError("Invalid phone number");
            return;
        }
        if (/^0{5,}/.test(v)) {
            setPhoneError("Invalid phone number");
            return;
        }
        setPhoneError("");
    };

    const handleOTP = (e) => {
        let v = onlyDigits(e.target.value).slice(0, 6);
        setOtp(v);

        if (!validateOtp(v)) setOtpError("OTP must be numbers only");
        else setOtpError("");
    };

    const handleNewPassword = (e) => {
        let v = clean(e.target.value);
        setNewPassword(v);

        if (!validatePassword(v))
            setNewPasswordError("Min 8 chars, 1 number & 1 special character");
        else setNewPasswordError("");
    };


    const handleLogin = async (e) => {
        e.preventDefault();

        if (!email || emailError || !password || passwordError) {
            toast.error("Invalid Credentials");
            return;
        }

        const obj = { email, password };
        const res = await AuthService.Login(obj);

        if (res?.data) {
            const user = res.data.data.civilEngsDetails;
            const token = res.data.data.token;

            if (user?.activeStatus === "Active") {
                toast.success("Login Successful");

                setTimeout(() => {
                    localStorage.setItem("token", token);
                    localStorage.setItem("userDetails", JSON.stringify(user));

                    if (user?.status === "Pending" || !user?.Personal_Details?.length) {
                        navigate("navbar/profile-edit");
                    } else {
                        navigate("navbar/dashboard");
                    }
                }, 800);
            } else {
                setEngineerStatus(user?.activeStatus);
                setIsModalOpen(true);
            }
        } else {
            toast.error("Login Failed");
        }
    };

    const handleSignup = async (e) => {
        e.preventDefault();

        let hasError = false;

        if (!userName) { setUserNameError("Username required"); hasError = true; }
        if (!firstName) { setFirstNameError("First Name required"); hasError = true; }
        if (!lastName) { setLastNameError("Last Name required"); hasError = true; }
        if (!email || emailError) { setEmailError("Invalid Email"); hasError = true; }
        if (!password || passwordError) { hasError = true; }
        if (!confirmPassword || confirmPasswordError) { hasError = true; }
        if (!phone || phoneError) { hasError = true; }

        if (hasError) return;

        const obj = {
            email,
            password,
            confirmPassword,
            phoneNumber: phone,
            countryCode: "+91",
            name: userName,
            firstName,
            middleName,
            lastName,
            aadharNumber: "-",
            userType: "civil engineer",
        };

        const res = await AuthService.Signup(obj);

        if (res.data) {
            setToggle("otp");
            setTimeLeft(30);
        } else {
            setError(res)
        }
    };


    const resendOtp = async () => {
        if (timeLeft > 0) return;

        const res = await AuthService.resendOtp({ email });

        if (res.data) {
            setOtp("");
            toast.success("OTP Sent Successfully");
            setTimeLeft(30);
        } else {
            toast.error("Failed to send OTP");
        }
    };


    const verifyingOtp = async () => {
        if (!otp) {
            setOtpError("OTP required");
            return;
        }

        const res = await AuthService.verifyOtp({ email, otp });

        if (res.data) {
            toast.success("Registration Successful");

            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("userDetails", JSON.stringify(res.data.data.civilEngsDetails));

            navigate("navbar/profile-edit");
        } else {
            toast.error("Invalid OTP");
        }
    };
    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const res = await AuthService.googleLogin({
                idToken: credentialResponse.credential
            });

            if (res.data && res.data.isNewUser) {
                toast.info("No account found with this email. Please complete registration.");

                // Auto-fill fields from backend response
                setEmail(res.data.googleData.email || "");
                setFirstName(res.data.googleData.firstName || "");
                setLastName(res.data.googleData.lastName || "");
                // Assuming the backend might send middleName, otherwise default to empty
                setMiddleName(res.data.googleData.middleName || "");
                setToggle("signUp"); // Redirect to Signup
                return;
            }
            // Standard Login Logic (matching your handleLoginSubmit)
            if (res?.data?.message === "Success") {
                const authData = res.data.data;
                if (authData.civilEngsDetails) {
                    localStorage.setItem("token", authData.token);
                    localStorage.removeItem("docity_onboarding_completed");
                    localStorage.setItem("userDetails", JSON.stringify(authData.civilEngsDetails));

                    toast.success("Logged in with Google!");
                    navigate("/");
                } else {
                    setToggle("signUp");
                    toast.error("Please sign in with Civil Engineer credentials.");
                }
            } else {
                toast.error(typeof res === 'string' ? res : "Google authentication failed.");
            }
        } catch (error) {
            console.error("Google Success Error:", error);
            toast.error("An error occurred during Google sign-in.");
        }
    };

    const verifyEmail = async () => {
        if (!email || emailError) {
            setEmailError("Enter valid email");
            return;
        }

        const res = await AuthService.forgotPassword({ email });

        if (res.data) {
            toast.success(`OTP sent to ${email}`);
            setToggle("forgotOtp");
            setTimeLeft(30);
        } else {
            toast.error("Email not found");
        }
    };


    const verifyForgotOTP = async () => {
        let hasError = false;

        if (!otp) { setOtpError("OTP required"); hasError = true; }
        if (!newPassword || newPasswordError) { hasError = true; }

        if (hasError) return;

        const obj = { email, otp, newPassword };
        const res = await AuthService.changePassword(obj);

        if (res.data) {
            toast.success("Password Changed Successfully");
            setToggle("login");
        } else {
            toast.error("Failed to change password");
        }
    };

    return (
        <div className="container-fluid-login">
            <div className="row">
                <div className="col-md-12">

                    {toggle === "login" && (
                        <div className="login-split">
                            {/* Left Brand Panel */}
                            <div className="login-brand-panel">
                                <div className="brand-content">
                                    <img src={whiteLogo} alt="DoCity" className="brand-logo" />
                                    <h2 className="brand-title">Civil Engineer Portal</h2>
                                    <p className="brand-description">
                                        Manage property verifications, track assignments, and collaborate across the DoCity platform.
                                    </p>
                                    <ul className="brand-features">
                                        <li>✓ Accept and complete property verifications</li>
                                        <li>✓ Track your assigned properties</li>                                    </ul>
                                </div>
                            </div>

                            {/* Right Form Panel */}
                            <div className="login-form-panel">
                                <div className="form-content">
                                    <h2 className="form-title">Sign in</h2>
                                    <p className="form-subtitle">Enter your engineer credentials to continue</p>

                                    <form onSubmit={handleLogin}>
                                        <label className="field-label">EMAIL</label>
                                        <input
                                            type="text"
                                            className="email-login"
                                            placeholder="you@docity.in"
                                            value={email}
                                            onChange={handleEmail}
                                        />
                                        {emailError && <p className="validation-erro">{emailError}</p>}

                                        <label className="field-label">PASSWORD</label>
                                        <div className="password-container">
                                            <input
                                                type={passwordShow ? "text" : "password"}
                                                className="password-login"
                                                placeholder="Enter your password"
                                                value={password}
                                                onChange={handlePassword}
                                            />
                                            <span
                                                className="toggle-password"
                                                onClick={() => setPasswordShow(!passwordShow)}
                                            >
                                                <img src={passwordShow ? view : hide} width={25} alt={passwordShow ? "Show" : "Hide"} />
                                            </span>
                                        </div>
                                        {passwordError && <p className="validation-erro">{passwordError}</p>}

                                        <p className="forgot-link" onClick={() => setToggle("forgot")}>Forgot password?</p>

                                        <button type="submit" className="btn buttonwith">Sign in</button>

                                        <div className="register">
                                            <div className="google-login-container">
                                                <GoogleLogin
                                                    onSuccess={handleGoogleSuccess}
                                                    onError={() => toast.error("Google Login Failed")}
                                                    useOneTap
                                                />
                                            </div>
                                            <p>
                                                Don't have an account?{" "}
                                                <span onClick={() => setToggle("signUp")}>Register</span>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                    {toggle === "signUp" && (
                        <div className="login-form">
                            <div className="login-logo"><img src={logo} alt="Logo" /></div>
                            <h4>Civil Engineer Registration</h4>

                            <form onSubmit={handleSignup}>
                                <input
                                    type="text"
                                    className="user-login"
                                    placeholder="Enter Username"
                                    value={userName}
                                    onChange={handleUserName}
                                />
                                {userNameError && <p className="validation-erro">{userNameError}</p>}

                                <input
                                    type="text"
                                    className="user-login"
                                    placeholder="Enter First Name"
                                    value={firstName}
                                    onChange={handleFirstName}
                                />
                                {firstNameError && <p className="validation-erro">{firstNameError}</p>}

                                <input
                                    type="text"
                                    className="user-login"
                                    placeholder="Enter Middle Name (Optional)"
                                    value={middleName}
                                    onChange={handleMiddleName}
                                />

                                <input
                                    type="text"
                                    className="user-login"
                                    placeholder="Enter Last Name"
                                    value={lastName}
                                    onChange={handleLastName}
                                />
                                {lastNameError && <p className="validation-erro">{lastNameError}</p>}

                                <input
                                    type="text"
                                    className="email-login"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={handleEmail}
                                />
                                {emailError && <p className="validation-erro">{emailError}</p>}

                                <input
                                    type="password"
                                    className="password-login"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={handlePassword}
                                />
                                {passwordError && <p className="validation-erro">{passwordError}</p>}

                                <div className="password-container">
                                    <input
                                        type={passwordShow2 ? "text" : "password"}
                                        className="password-login"
                                        placeholder="Confirm Password"
                                        value={confirmPassword}
                                        onChange={handleConfirmPassword}
                                    />
                                    <span
                                        className="toggle-password"
                                        onClick={() => setPasswordShow2(!passwordShow2)}
                                    >
                                        <img src={passwordShow2 ? view : hide} width={25} alt={passwordShow2 ? "Show password" : "Hide password"} />
                                    </span>
                                </div>
                                {confirmPasswordError && (
                                    <p className="validation-erro">{confirmPasswordError}</p>
                                )}

                                <div className="d-flex align-items-center phone-input-wrapper">
                                    <div style={{
                                        padding: '0 10px',
                                        backgroundColor: '#f3f4f6',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px 0 0 8px',
                                        borderRight: 'none',
                                        color: '#4b5563',
                                        fontSize: '14px',
                                        height: '44px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '55px',
                                        fontWeight: '500'
                                    }}>
                                        +91
                                    </div>
                                    <input
                                        type="text"
                                        className="phone-login"
                                        placeholder="Enter Phone Number"
                                        value={phone}
                                        onChange={handlePhone}
                                        style={{ borderRadius: '0 8px 8px 0', flex: 1, minWidth: 0 }}
                                    />
                                </div>
                                {phoneError && <p className="validation-erro">{phoneError}</p>}
                                {error && <p className="validation-erro">{error}</p>}
                                <div className="row setCenterThebutton">
                                    <div className="col-md-4">
                                        <button type="submit" className="btn buttonwith">Sign Up</button>
                                    </div>
                                </div>


                                <div className="register">
                                    <p>
                                        Already have an account?{" "}
                                        <span onClick={() => setToggle("login")}>Login</span>
                                    </p>
                                </div>
                            </form>
                        </div>
                    )}
                    {toggle === "otp" && (
                        <div className="otp-wrapper">
                            <div className="otp-card">
                                <div className="otp-logo-container">
                                    <img src={logo} alt="DoCity" className="otp-logo-img" />
                                </div>

                                <div className="otp-icon-circle">
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="4" width="20" height="16" rx="2"/>
                                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                    </svg>
                                </div>

                                <h3 className="otp-title">Verify Your Email</h3>
                                <p className="otp-subtitle">
                                    Enter the 6-digit OTP sent to<br/>
                                    <strong>{email}</strong>
                                </p>

                                <div className="otp-field-group">
                                    <label className="otp-field-label">OTP CODE</label>
                                    <input
                                        type="text"
                                        className="otp-input-field"
                                        placeholder="Enter 6-digit OTP"
                                        maxLength={6}
                                        value={otp}
                                        onChange={handleOTP}
                                        autoFocus
                                    />
                                    {otpError && <p className="validation-erro">{otpError}</p>}
                                </div>

                                <button className="btn verify otp-btn" onClick={verifyingOtp}>
                                    Verify OTP
                                </button>

                                {timeLeft > 0 ? (
                                    <p className="otp-timer">
                                        Resend OTP in <strong>{timeLeft}s</strong>
                                    </p>
                                ) : (
                                    <p className="otp-resend" onClick={resendOtp}>Resend OTP</p>
                                )}

                                <p className="otp-back-link" onClick={() => setToggle("signUp")}>
                                    ← Back to Sign Up
                                </p>
                            </div>
                        </div>
                    )}


                    {toggle === "forgot" && (
                        <div className="d-flex justify-content-center align-items-center vh-100">
                            <div className="card p-4 custom-card text-center">
                                <div className="Logo mb-4">
                                    <img src={logo} width={150} alt="Logo" />
                                </div>
                                <div className="forgot-form d-flex justify-content-center align-items-center gap-3 flex-wrap">
                                    <input
                                        type="text"
                                        className="custom-input"
                                        placeholder="Enter registered email address"
                                        value={email}
                                        onChange={handleEmail}
                                    />
                                    <div className="d-flex login">
                                        <button type="submit" className="btn" onClick={verifyEmail}>
                                            Verify Email
                                        </button>
                                    </div>
                                </div>
                                {emailError && <p className="text-danger mt-3">{emailError}</p>}
                            </div>
                        </div>
                    )}

                    {toggle === "forgotOtp" && (
                        <div className="forgot-otp-wrapper">
                            <div className="forgot-otp-card">

                                <img src={logo} width={120} alt="Logo" className="forgot-otp-logo" />

                                <h3 className="forgot-otp-title">Reset Your Password</h3>
                                <p className="forgot-otp-subtitle">
                                    Enter the OTP sent to your email
                                </p>

                                <div className="forgot-otp-input-group">
                                    <input
                                        type="text"
                                        className="forgot-otp-input"
                                        placeholder="Enter OTP"
                                        value={otp}
                                        maxLength={6}
                                        onChange={handleOTP}
                                    />
                                    {otpError && <p className="validation-erro">{otpError}</p>}

                                    <input
                                        type="password"
                                        className="forgot-password-input"
                                        placeholder="Enter New Password"
                                        value={newPassword}
                                        onChange={handleNewPassword}
                                    />
                                    {newPasswordError && (
                                        <p className="validation-erro">{newPasswordError}</p>
                                    )}
                                </div>

                                {timeLeft > 0 ? (
                                    <p className="forgot-otp-timer">
                                        Resend OTP in <strong>{timeLeft}s</strong>
                                    </p>
                                ) : (
                                    <p className="forgot-resend" onClick={resendOtp}>
                                        Resend OTP
                                    </p>
                                )}

                                <button className="btn verify forgot-otp-btn" onClick={verifyForgotOTP}>
                                    Verify OTP
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <CivilStatusModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                status={engineerStatus}
            />

            <ToastContainer autoClose={2000} />
        </div>
    );
};

export default Login;
